import React, { useCallback, useEffect, useRef, useState } from 'react'

import Link from '@components/_Revamp/Link';
import Text from '@components/Text';
import Stepper from '@components/_Revamp/Stepper';
import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import { useDispatch } from 'react-redux';
import { themeDefault } from 'src/theme-revamp';
import MyInfoMessageBox from './components/MyInfoMessageBox';
import SinglifeBorderBox from './components/SinglifeBorderBox';
import SinglifeQRCode from './components/SinglifeQRCode';
import { get, isEmpty, toArray } from 'lodash';
import { postQASPostalAddress, getAuthoriseURL, getPerson, postSavingMyInfo, getRentalProperty, postContactMltc } from '@api/index';
import Dropdown from '@components/_Revamp/DropdownInput';
import Input from '@components/_Revamp/Input';
import NameSelector, { NameSelectorItemProps } from '@components/_Revamp/NameSelector';
import Modal from '@components/_Revamp/Modal';
import Button from '@components/_Revamp/Button';
import Accordion, { AccordionProps } from '@components/_Revamp/Accordion';
import Bullet from '@components/_Revamp/Bullet';
import { useHistory } from 'react-router-dom';
import { scrollToRef } from '../../../utils/scrollScript';
import Listing from '@components/_Revamp/Listing';
import { Checkbox } from '@components/_Revamp/Checkbox';
import { MyInfoAddressForm } from '@models/MLTC_R3/AddressDetails.model';
import { HealthDeclarationForm } from '@models/MLTC_R3/HealthDeclaration.model';
import { useAvivaSelector } from '@redux/hook';
import useForm from '@utils/useForm';
import { validateAddMyInfoForm, validateAddress, validateDeclaration, validateInfoDetails } from './service';
import { Helpers } from '@utils/helpers';
import { completeMyInfoStep, completeStep, resetToIntialStateStep4, updateDeclaration, updateHasMyInfo, updateL400, updateMyInfoAddressForm, updateMyInfoForm, updateMyInfoInTouch, updateMyInfoRawResponse, updatePersonalDetails, updateRetrievedMyInfo } from '@redux/slices/MLTC_R3/step4Slice';
import { AddMyInfoRequest, IMyInfoQuestionRequest, MyInfoPersonResponse } from '@models/MyInfoRequest.model';
import { AgentPersonalDetailResponse } from '@models/AgentPersonalDetailRequest.model';
import { AddMyInfoForm, MyInfoForm } from '@models/MLTC_R3/MyInfo.model';
import { QASPostalCodeRequest, QASPostalCodeResponse } from '@models/QASPostalCodeRequest';
import { DeclarationForm } from '@models/MLTC_R3/Declaration.model';
import { calculateSpacer } from '../../../utils/spaceCalculation';
import { GAAviva, MLTC_R3_JOURNEY_NAME } from '@utils/gaAvivaR3';
import { setIsGlobalError, setLoadingState } from '@redux/slices/loadingSlice';
import AddMyInfoModal from './components/AddMyInfo';
import { Step } from '@components/_Revamp/Stepper/Stepper';
import BottomSheet from '@components/_Revamp/BottomSheet';
import ModalNameSelector from './components/ModalNameSelector';
import { CIMB_Code } from '@static/campaign-code';
import MyInfoErrorMessage from './components/MyInfoErrorMessageBox';
import Icon from '@components/_Revamp/Icon';
import UnitToolTipComponent from './components/UnitToolTip';
import { UOB_CONTACT_URL } from '@static/config';
import SingpassPermission from './components/SingpassPermission';
import { createContactRequest, getTimestamp } from '../ContactForm';
import { SQSPocketResponse } from '@models/MLTC/SQSPocketRequest.model';
import { updateTransactionId } from '@redux/slices/MLTC_R3/step2Slice';

const MobileCountryCode = styled.label`
  font-size: 16;
  font-weight: 600;
  line-height: 1.4;
  color: #C9C9C9;
  border-bottom: 1px solid #C4C4C4;
  padding-right: 4px;
`;


const MobileInputGroup = styled.div`
  display: flex;
`;



const Container = styled.div`
  position:relative;
  margin: 0 auto;
  max-width: 1230px;
  display: block;
  flex-wrap: wrap;
  @media screen and (max-width: 1280px) {
    padding: 0;
  }
  @media screen and (max-width: 768px) {
    padding: 0;
  }
   
`;
const ContentContainer = styled.div<FormHeaderContainerProps>`
  display:block;
  transition: all 0.2s ease;
  margin: 200px auto 100px auto;
  padding: 0;
  @media screen and (min-width: 768px) {
    margin: 200px auto 50px auto;
    max-width:588px;
  }
  @media screen and (min-width: 1024px) {
    padding: 0 200px;
    max-width: ${props => props.maxWidth ? props.maxWidth : "unset"};  
  }
  @media screen and (min-width: 1250px) {
    margin: ${props => props.margin ? props.margin : "unset"};
  }

`;
const TitleContainer = styled.div`
  display: block;
  margin-bottom:24px;
  padding: 0 24px;
  @media screen and (min-width: 768px) {    
    padding: 0;
  }
`;
const CheckboxAddressContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0;
  column-gap: 20px;
`;
const CheckboxAddressContainerList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 48px;
  margin: 0 10px;
  @media screen and (min-width: 768px) {
    margin: 0 80px;
  }
 
`;
const DeclarationBulletsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0 100px;
  row-gap: 10px;
  @media screen and (max-width: 768px) {
    margin: 0 20px;
  }
`;

const HeaderTitleCss = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  line-height: 140%;
  color: #434343;
  @media screen and (max-width: 768px) {
    font-size: 20px;
  }
`;
const AddressHeaderTitleCss = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  line-height: 140%;
  color: #883E89;
`;
const paragraphCss = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 180%;
  color: #434343;
  a{
    font-weight: 600;
    font-size: 16px;
  }
  @media screen and (max-width: 768px) {
    font-size: 14px;
    font-weight: 500;
    a{
      font-weight: 500;
      font-size: 14px;
    }
  }
`;
const errorParagraphCss = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 180%;
  color: #434343;
  a{
    font-weight: 600;
    font-size: 16px;
  }
  span{
    font-weight: 600;
    font-size: 16px;
    color: #C50000;
    a{
      u{
        border-color: #C50000;
      }
    }
  }
  @media screen and (max-width: 768px) {
    font-size: 14px;
    font-weight: 500;
    a{
      font-weight: 500;
      font-size: 14px;
    }
    span{
      font-weight: 500;
      font-size: 14px;
      color: #C50000;
    }
  }
`;

const errorToContactCss = css`
  border-bottom: 1px solid #C50000;
  cursor: pointer;
  font-weight: 600;
  font-size: 16px;
  color: #C50000;
  @media screen and (max-width: 768px) {
    font-size: 14px;
    font-weight: 500;
  }
`;

const checkBoxParagraphCss = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 140%;
  color: #434343;
  a{
    font-weight: 500;
    font-size: 14px;
  }
  @media screen and (max-width: 768px) {
    font-size: 14px;
    font-weight: 500;
    a{
      font-weight: 500;
      font-size: 14px;
    }
  }
`;

const tncParagraph = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 180%;
  color: #434343;
  a{
    font-weight: 600;
    font-size: 16px;
  }
  @media screen and (max-width: 768px) {
    font-size: 14px;
    font-weight: 500;
    a{
      font-weight: 500;
      font-size: 14px;
    }
  }
`;

const CheckboxTextCss = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  color: #434343;
  @media screen and (min-width: 768px) {
    font-weight: 400;
  }
`;
const AddressListingContainer = styled.div<FormHeaderContainerProps>`
  display: block;
  max-width: ${props => props.maxWidth ? props.maxWidth : "unset"};
  width: 100%;
  margin: ${props => props.margin ? props.margin : "auto"};
  @media screen and (max-width: 768px) {
  }
`;
const FormContainer = styled.div<FormHeaderContainerProps>`
  max-width: ${props => props.maxWidth ? props.maxWidth : "unset"};
  opacity: 0;
  -webkit-transition: opacity 0.5s ease-in;
  -moz-transition: opacity 0.5s ease-in;
  -o-transition: opacity 0.5s ease-in;
  -ms-transition: opacity 0.5s ease-in;
  transition: opacity 0.5s ease-in;
  flex-direction:column;
  align-content:center;
  margin: ${props => props.margin ? props.margin : "150px auto 0 auto"};
  display: flex;
  flex-wrap: wrap;
  transition: all 0.2s ease;
  
  justify-content:center;
  margin: 200px auto 100px auto;
  max-width: 327px;
  padding: 0 24px;
  
  @media screen and (min-width: 768px) {
    max-width: 588px;
    margin: 200px auto 50px auto;
    padding: 0;
  }
  @media screen and (min-width: 1024px) {
    max-width: ${props => props.maxWidth ? props.maxWidth : "unset"};
    margin: ${props => props.margin ? props.margin : "unset"}; 
    padding:0 200px;
  }

`;
const FormHeaderContainer = styled.div`
  display: block;
  margin: 0 auto 64px;
  @media screen and (max-width: 768px) {
    margin: 0 auto 24px;
  }
`;
const FormContentContainer = styled.div<FormHeaderContainerProps>`
  max-width: ${props => props.maxWidth ? props.maxWidth : "unset"};
  margin: ${props => props.margin ? props.margin : "0 20px;"};
  display: flex;
  flex-wrap: wrap;
  flex-direction:row;
  justify-content: space-between;
  flex-direction: row;
  column-gap: 24px;
  row-gap: 36px;
  .firstname, .lastname {
    input {
      color: #883e89;
    }
  }
  @media screen and (max-width: 1024px) {
    justify-content: space-between;
  }
  @media screen and (max-width: 768px) {
    justify-content: space-between;
    flex-direction:column;
    width: 100%;
    .fullname {
      order: -1;
    }
    .firstname {
      order: -1;
    }
    .lastname {
      order: -1;
    }
  }
 
 
`;

const FormContentItemsSearchCss = css`
  align-self: center;
  width: unset !important;
  margin: unset !important;
  button{
    margin: unset !important;
  }
  @media screen and (max-width: 768px) {
    width: 100% !important;
    margin: -38px auto 0 !important;
    button{
      margin: auto !important;
    }
  }
`;

const FormContentItemsContainer = styled.div`
  flex:0 0 282px;
  margin-top:0;
  @media screen and (max-width: 768px) {
    flex:1;
  }
`;
const FormHeaderTitleContainer = styled.div<FormHeaderTitleContainerProps>`
  max-width: ${props => props.maxWidth ? props.maxWidth : "unset"};
  display: block;
  margin: 0;
  margin-bottom:16px;
  @media screen and (min-width: 768px) {
    margin: 0 50px 16px;
  }
  @media screen and (min-width: 1024px) {
    margin: 0 ${props => props.marginHorizontal} 16px;
  }
  
`;
const FormHeaderDescriptionContainer = styled.div`
  display: block;
  margin: 0 0;
  @media screen and (max-width: 768px) {
    padding: 0;
  }
`;
const FormButtonContainer = styled.div`
  display:flex;
  justify-content:center;
  margin-top:80px;
  column-gap:40px;
  @media screen and (max-width: 768px) {
    column-gap:0;
    row-gap:10px;
    flex-direction:column;
    align-items: center;
  }
`;
const AccordionContainer = styled.div`
  margin-top: 120px;
  padding-bottom:20px;
  @media screen and (max-width: 768px) {
  }
`;
const CheckboxContainer = styled.div`
  margin: 0 130px;
  @media screen and (max-width: 768px) {
    margin: 0 50px;
  }
`;
const CheckboxTermsContainer = styled.div`
  opacity: 0;
  -webkit-transition: opacity 0.3s ease-in;
  -moz-transition: opacity 0.3s ease-in;
  -o-transition: opacity 0.3s ease-in;
  -ms-transition: opacity 0.3s ease-in;
  transition: opacity 0.3s ease-in;
  margin-top: 36px;
  margin-bottom:50px;
  @media screen and (max-width: 768px) {
    margin: 36px 0 0;
    opacity: 1;
  }
`;

const FormLabel = styled.label<{ isError?: boolean }>`
  display:inline-block;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 180%;
  color: ${props => props.isError ? '#C50000' : '#434343'};
  margin-bottom:17px;
`;
const MessageNote = styled.p<MessageNoteProps>`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 140%;
  color: ${props => props.color ? props.color : "#8C8C8C"};
  padding: 8px 0 0 0;
  @media screen and (max-width: 768px) {
    padding: 8px 5px 0 0;
  }
`


const HeaderDescriptionCss = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  text-align: center;
  color: #8A8988;
  @media screen and (min-width: 768px) {
    font-weight: 600;
  }
`;

const FullNameParagraph = styled.p`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  color: #434343;
`;
const AccordionParagraph = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 25.2px;
  color: #434343;  
`;
const DeclarationParagraph = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 180%;
  color: #444444;  
`;


const AddressTermsParagraph = css`
font-family: 'Open Sans';
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 140%;
color: #444444;  
margin: 0 24px;
margin-top:12px;
`;


const SpanParagraphCss = css`
  color: #883E89;
  border-bottom: 1px solid #883E89;
  cursor: pointer;
`;

const container_default_css = css`
  margin-bottom:0px;
`;

const title_default_css = css`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  @media screen and (max-width: 768px) {
    width: unset;
    font-size:16px;
  }
`;

const ActionContainer = styled.div`
  display: flex;
  align-items:center;
  justify-content: center;
  flex-direction:column;
  row-gap: 8px;
  margin-top: 50px;
  @media screen and (min-width: 768px) {
    flex-direction:row;
    column-gap: 24px;
    margin-top: 48px;
  }
`;

const ButtonCloseContainer = styled.div`
  padding: 4.24px 4.24px 0 0;
  height: 13.5px;
  width: 13.5px;
  cursor: pointer;
`;

const UnitTooltipIconContainer = styled.div`
  display:inline-block;
  cursor: pointer;
  position: relative;
  left: 7px;
  top: 4.5px;
  width:18px;
  height:18px;
`;

const MarketUpdateLinks = styled.a`
color: #883E89;
font-size: 12px;
font-style: normal;
font-weight: 600;
line-height: 140%;
`;

const MarketTermsHeader = styled.div`
  font-size: 18px;
  font-style: normal;
  display: flex;
  margin-top: 64px;
  font-weight: 600;
  color: #000;
  &:before {
    content: "";
    margin-top: -5px;
    margin-right: 16px;
    border-radius: 4px;
    border: 4px solid #883E89;
  }
`;

const MarketTermsUpdate = styled.div`
color: #434343;
font-size: 12px;
font-style: normal;
font-weight: 500;
line-height: 140%;

@media screen and (max-width: 588px) {
  /*font-size: 14px;
   font-weight: 400; */
  line-spacing: 19.6px;
}
`;

const TextNormal = styled.div`
  color: #434343;
  font-weight: 400; 
  font-size: 14px;
  margin: 0;
  /* letter-spacing: 140%; */

  @media screen and (max-width: 588px) {
    /*font-size: 14px;
     font-weight: 400; */
    line-spacing: 19.6px;
  }
`;

const MarketTermsDescription = styled.div`
  font-size: 14px;
  font-style: normal;
  margin: auto;
  font-weight: 400;
  line-height: 140%;
  color: #8A8988;
`;





export interface MessageNoteProps {
  color?: string;
}

export interface StepInterface {
  label: string;
  isCurrentStep: boolean;
}
export interface FormHeaderTitleContainerProps {
  marginHorizontal: string;
  maxWidth?: string
}
export interface FormHeaderContainerProps {
  margin?: string;
  maxWidth?: string
}

const ContactUsUrl = get(window, 'AVIVA_VARIABLE_CONFIG.avivaContactUsUrl');
const DPOUrl = "https://mysinglife.singlife.com/";


const salutationListM = [
  { id: 'Mr', label: 'Mr' },
  { id: 'Master', label: 'Master' },
  { id: 'Dr', label: 'Dr' },
  { id: 'Professor', label: 'Professor' },
]
const salutationListF = [
  { id: 'Mrs', label: 'Mrs' },
  { id: 'Ms', label: 'Ms' },
  { id: 'Mdm', label: 'Mdm' },
  { id: 'Dr', label: 'Dr' },
  { id: 'Professor', label: 'Professor' },
]

const annualIncomeList = [
  { id: '23999', label: 'Less than S$24,000' },
  { id: '24001', label: 'S$24,001 to S$36,000' },
  { id: '36001', label: 'S$36,001 to S$60,000' },
  { id: '60001', label: 'S$60,001 to S$100,000' },
  { id: '100001', label: 'More than S$100,000' },
]

const accordionArgs = {
  theme: themeDefault,
  className: container_default_css,
  title: 'Why do you need to indicate your personal income?',
  titleColor: '#434343',
  headerPadding: '24px 24px 24px 0',
  titleClassName: title_default_css,
  titleFontSize: 16,
  isExpanded: true,
  showBottomLine: true,
  showHeaderLine: true,
  bottomLineColor: '#c4c4c4',
  bottomLineThickness: '1px',
  contentMarginLeft: '0',
  contentMarginRight: '0',
  bottomLineClassName: 'margin:10px'
}
const MyInfo = () => {
  const history = useHistory();

  const dispatch = useDispatch();

  const SpacerRef = useRef<null | HTMLDivElement>(null);
  const AccordionRef = useRef<any>();
  const unitToolTipComponentRef = useRef<any>();

  const [isSingPassRetrieved, setSingPassRetrieved] = useState<boolean>(false);
  const [isPageLoaded, setIsPageLoaded] = useState<boolean>(false);
  const gioDeclaration = useAvivaSelector(state => state.mltcR3Step2.gioDeclaration);
  const cstopupCampaignValidity = useAvivaSelector(state => state.mltcR3Step2.cstopupCampaignValidity);
  const gioNricDetails = useAvivaSelector(state => state.mltcR3Step2.gioNricDetails);
  const [campaignCode, setCampaignCode] = useState<string>('MLO1');
  const campaignDetail = useAvivaSelector(state => state.loading.campaignDetail);  
  const basicDetails = useAvivaSelector(state => state.mltcR3Step1.basicDetails);
  const age = basicDetails?.dob
    ? Helpers.getAge(
        new Date(
          `${basicDetails.dob.month}/${basicDetails.dob.day}/${basicDetails.dob.year}`,
        ),
      )
    : null;
  const isEBLTC = campaignDetail?.code === "EBLTC" && campaignDetail?.status !== "EXPIRED" && age !== null && (age >= 31 && age <= 40);;
  const companyName = campaignDetail?.companyName || "";
  const [isGenericError, setIsGenericError] = useState<boolean>(false);
  const [myInfoRawResponse, setMyInfoRawResponse] = useState<any>(null);
  const [personalDetails, setPersonalDetails] = useState<any>(null);
  const [addressInformation, setAddressInformation] = useState<any>(null);
  const [isInjected, setInjected] = useState<boolean>(false);
  const [isShowMyInfoPopup, setShowMyInfoPopup] = useState<boolean>(false);
  const [isLanded, setLanded] = useState<boolean>(false);
  const [aaTracking,setAATracking] = useState<string[]>([]);

  const transactionId = useAvivaSelector(state => state.mltcR3Step2.transactionId);
  const initValue = useAvivaSelector(state => state.mltcR3Step4.myInfoForm);
  const initInTouchValue = useAvivaSelector(state => state.mltcR3Step4.myInfoInTouchValue);
  const salutations = useAvivaSelector(state => state.staticData.salutations);
  const nationlaities = useAvivaSelector(state => state.staticData.nationlaities);
  const races = useAvivaSelector(state => state.staticData.races);
  const maritalStatus = useAvivaSelector(state => state.staticData.maritalStatus);
  const healthDeclaration = useAvivaSelector(state => state.mltcR3Step3.healthDeclaration);
  const isShowAddMyInfo = useAvivaSelector(state => state.loading.isShowAddMyInfo);
  const coverages = useAvivaSelector(state => state.mltcR3Step1.coverage);
  const initAddressValue = useAvivaSelector(state => state.mltcR3Step4.myInfoAddressForm);
  const declaratinInitialValue = useAvivaSelector(state => state.mltcR3Step4.declaration);
  const planOverview = useAvivaSelector(state => state.mltcR3Step2.planOverview);
  const sqsQuotation = useAvivaSelector(state => state.mltcR3Step2.sqsQuotation);
  const isStep3Completed = useAvivaSelector(state => state.mltcR3Step3.isCompleted);
  const personRawResponse = useAvivaSelector(state => state.mltcR3Step4.myInfoRawResponse);
  const isDifferenceAddressRef = useRef<number>(isEmpty(initAddressValue) ? 0 : 1);
  const [isFindAddressValid, setIsFindAddressValid] = useState<boolean>(true);
  const analyticUrlParams = useAvivaSelector(state => state.urlAnalytic.param);
  const combineAnalyticParam = Helpers.getUrlAnalyticParams(true, analyticUrlParams);
  const quoteRawResponse = useAvivaSelector(state => state.mltcR3Step2.quoteRawResponse);
  const qrClientDetails = useAvivaSelector(
    (state) => state.mltcR3Step5.qrClientDetails,
  );
  const validQRClient = qrClientDetails?.status === "SUCCESS";

  const urlParams: URLSearchParams = Helpers.getURLSearchParams();

  const stepsList: Step[] = [
    {
      label: 'Basic Info',
      isCurrentStep: false,
      path: "/mltc/lets-get-started",
      disabled: validQRClient
    },
    {
      label: 'Quote',
      isCurrentStep: false,
      path: "/mltc/choose-plan"
    },
    {
      label: 'Health Declaration',
      isCurrentStep: false,
      path: "/mltc/health",
      disabled: gioDeclaration === "GIO",
    },
    {
      label: 'Start Application',
      isCurrentStep: true,
      path: "/mltc/my-info"
    },
    {
      label: 'Review & Payment',
      isCurrentStep: false,
      path: "/mltc/review"
    },
  ];
  

  //============MyInfo==============

  const [firstNameModalVisible, setFirstNameModalVisible] = useState<boolean>(false);
  const [lastNameModalVisible, setLastNameModalVisible] = useState<boolean>(false);

  const [firstNameListingChucks, setFirstNameListingChucks] = useState<NameSelectorItemProps[]>([]);
  const [lastNameListingChucks, setLastNameListingChucks] = useState<NameSelectorItemProps[]>([]);
  const [isMyInfoCompleted, setMyInfoCompleted] = useState<boolean>(false);

  const [isFormError, setIsFormError] = useState<boolean>(true);

  //=============End MyInfo==========
  //============MyInfo Addresses==============

  const [infoAddressFormErrors, setInfoAddressFormErrors] = useState<boolean>(false);
  const [isAddressEdit, setAddressEdit] = useState<boolean>(false);
  const [isAddressCompleted, setAddressCompleted] = useState<boolean>(false);
  const [checkUpdateAddressPolicy, setCheckUpdateAddressPolicy] = useState<boolean>(false);

  const [block, setBlock] = useState<string>("");
  const [unit, setUnit] = useState<string>("");
  const [streeName, setStreeName] = useState<string>("");
  const [postalCode, setPostalCode] = useState<string>("");
  const [buildingName, setBuildingName] = useState<string>("-");

  //=============End MyInfo Addresses==========

  //============MyInfo Contact==============

  const [contactMethods, setContactMethods] = useState<{selected:string, value:string[]}>({selected:"", value:[]});
  const [isShowUOB, setIsShowUOB] = useState<boolean>(false);


  //=============End MyInfo Contact==========



  //============MyInfo Declaration==============
  const [isDeclaration, setIsDeclaration] = useState<boolean>(false);
  //============End Declaration==============

  //============Detect Screen Width==============
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  const detectScreenWidth = () => {
    setScreenSize(window.innerWidth);
  };
  //============End Detect Screen Width==============


  const myInfoFormRef = useRef<null | HTMLDivElement>(null);
  const myInfoAddressFormRef = useRef<null | HTMLDivElement>(null);
  const myInfoAddressEditFormRef = useRef<null | HTMLDivElement>(null);
  const myInfoInTouchRef = useRef<null | HTMLDivElement>(null);
  const myInfoInTouchTermsRef = useRef<null | HTMLDivElement>(null);


  const retrievedMyInfo = useAvivaSelector(state => state.mltcR3Step4.retrievedMyInfo);
  const l400ProfileSlice = useAvivaSelector(state => state.mltcR3Step4.l400);  

  //Form Validation


  const { handleChange: handleChangeInfo, values: values, errors: infoFormErrors, formValid: infoFormValid, patchValue: patchValue } = useForm(new MyInfoForm(initValue), () => { }, validateInfoDetails);

  const { handleChange: changeAddressForm, values: addressValues, errors: addressFormErrors, formValid: addressFormValid, patchValue: patchValueAddressForm } = useForm(new MyInfoAddressForm(initAddressValue), () => { }, validateAddress);

  const { handleChange: changeDeclarationForm, values: declarationValues, formValid: declarationFormValid, patchValue: patchValueDeclaration } = useForm(new DeclarationForm(declaratinInitialValue), () => { }, validateDeclaration);


  const {
    handleChange: changeAddMyInfo,
    values: addMyInfoValues,
    formValid: addMyInfoFormValid,
    errors: addMyInfoError
  } = useForm(new AddMyInfoForm(null), () => { }, validateAddMyInfoForm);

  const paramCC = campaignDetail?.campaignCode ? `?cc=${campaignDetail.campaignCode}` : '';
  const analyticParam = Helpers.getUrlAnalyticParams(paramCC !== "", analyticUrlParams);

  const combineParamCC = campaignDetail?.campaignCode ? `&cc=${campaignDetail.campaignCode}` : '';
  const gotoUOBContact = () => {
    window.open(UOB_CONTACT_URL, "_blank", "noopener noreferrer");
  };

  const injectPersonData = {
    "data": {
      "code": 0,
      "id": 0,
      "person": {
        "uinfin": {
          "lastupdated": "-",
          "source": "0",
          "classification": "-",
          "value": "-"
        },
        "name": {
          "lastupdated": "-",
          "source": "0",
          "classification": "-",
          "value": "-"
        },
        "sex": {
          "lastupdated": "-",
          "code": "-",
          "classification": "-",
          "source": "0",
          "desc": "-"
        },
        "race": {
          "lastupdated": "-",
          "code": "-",
          "classification": "-",
          "source": "0",
          "desc": "-"
        },
        "nationality": {
          "code": "-",
          "desc": "-",
          "classification": "-",
          "source": "0",
          "lastupdated": "-"
        },
        "dob": {
          "lastupdated": "-",
          "source": "0",
          "classification": "-",
          "value": "-"
        },
        "email": {
          "lastupdated": "-",
          "source": "0",
          "classification": "-",
          "value": "-"
        },
        "mobileno": {
          "lastupdated": "-",
          "source": "0",
          "classification": "-",
          "areacode": {
            "value": "-"
          },
          "prefix": {
            "value": "-"
          },
          "nbr": {
            "value": "-"
          }
        },
        "regadd": {
          "lastupdated": "-",
          "source": "0",
          "classification": "-",
          "type": "-",
          "country": {
            "code": "-",
            "desc": "-"
          },
          "unit": {
            "value": "-"
          },
          "street": {
            "value": "-"
          },
          "block": {
            "value": "-"
          },
          "postal": {
            "value": "-"
          },
          "floor": {
            "value": "-"
          },
          "building": {
            "value": "-"
          }
        },
        "marital": {
          "code": "-",
          "desc": "-",
          "classification": "-",
          "source": "0",
          "lastupdated": "-"
        },
        "employment": {
          "lastupdated": "-",
          "source": "-",
          "classification": "-",
          "value": ""
        },
        "residentialstatus": {
          "lastupdated": "-",
          "code": "-",
          "classification": "-",
          "source": "0",
          "desc": "-"
        }
      }
    }
  }

  const checkboxHandleChange = (value: string) => {
    if (value === "Y") {
      setContactMethods({selected:'Y',value:['mail','email','sms','phone']});
      patchValueDeclaration({ mail: true,email: true,sms:true, phone:true });
    } else {
      setContactMethods({selected:'N',value:[]});
      patchValueDeclaration({ mail: false,email: false,sms:false, phone:false });
    }

  }
  const onClickRetrieveSingpass = async () => {
    dispatch(updateL400(addMyInfoValues['l400Profile']));
    dispatch(setLoadingState(true));
    try {
      const response = await getAuthoriseURL('mltc');
      const url = get(response, 'data.shortUrl', null);
      console.debug('getAuthoriseURL', url);
      window.open(url, '_self');
    } catch (error) {
      dispatch(setLoadingState(false));
      console.error(error);
    }
  };


  const getPersonByTransactionId = useCallback(async (transactionId: string) => {
    try {
      const response = await getPerson(transactionId, 'mltc');
      return response;
    } catch (error) {
      console.error(error);
      return false;
    }
  }, []);


  const handleConsent = useCallback(async () => {
    const transaction_id: string = urlParams.get('transaction_id') || '';
    console.log('QnB ➤ handleConsent() ➤', { transactionId, transaction_id });
    const status = urlParams.get('status');

    if (personRawResponse) { return; }
    dispatch(updateTransactionId(transaction_id));

    dispatch(setLoadingState(true));

    if (status === 'consent_accepted' && transaction_id) {
      const data = await getPersonByTransactionId(transaction_id);
      //const data = loadPersonMockData; //MOCK DATA
      if (data) {
        loadPerson(data);
      } else {
        if (!isGenericError) {
          setIsGenericError(true);
        }
        dispatch(setLoadingState(false));
      }
    } else {
      dispatch(setLoadingState(false));
      setIsGenericError(true);
    }
  }, []);

  const mapAddressInfo = (data: any) => {
    return [
      { text: 'Postal Code', value: get(data, 'postal', '-') || '-' },
      { text: 'Unit', value: get(data, 'floor', '') ? `${get(data, 'floor', '')}-${get(data, 'unit', '-')}` : get(data, 'unit', '-') || '-' },
      { text: 'Street Name', value: get(data, 'street', '-') || '-' },
      { text: 'Block', value: get(data, 'block', '-') || '-' },
      { text: 'Building Name', value: get(data, 'building', '-') || '-' },
    ]
  }

  const checkBasicDetails = useCallback((retrievedBasicDetails: any) => {
    const savedBasicDetails = basicDetails;
    const savedCoverages = coverages;
    console.debug(`QnB ➤ checkBasicDetails()`, { retrievedBasicDetails, basicDetails, savedCoverages });

    const dob = get(retrievedBasicDetails, 'dob');
    if ((Helpers.parseDobString(savedBasicDetails?.dob) !== dob) && dob !== '0') {
      console.log(`QnB ➤ checkBasicDetails() ➤ DOB compare ➤ `, Helpers.parseDobString(savedBasicDetails), dob);

      trackOnError("myinfo dob validation", "Please ensure date of birth matches with Myinfo data.", "1");
      dispatch(resetToIntialStateStep4(""))
      history.push('/mltc/lets-get-started?doberror=true' + combineParamCC + combineAnalyticParam);
      return false;
    }
    const gender = get(retrievedBasicDetails, 'gender');
    console.log(`QnB ➤ checkBasicDetails() ➤ Gender compare ➤ `, get(savedBasicDetails, 'gender', 'M'), gender);
    if ((get(savedBasicDetails, 'gender', 'M') !== gender) && (gender !== 'U' && gender !== '')) {
      trackOnError("myinfo gender validation", "Please ensure gender matches with Myinfo data.", "1");
      history.push('/mltc/lets-get-started?gendererror=true' + combineParamCC + combineAnalyticParam);
      return false;
    }
    const nric = get(retrievedBasicDetails, 'nric');
    console.log(`QnB ➤ checkBasicDetails() ➤ NRIC compare ➤ `, { 'not empty': !isEmpty(get(savedCoverages, 'promoNric', '')) }, get(savedCoverages, 'promoNric', ''), nric);
    if (!isEmpty(get(savedCoverages, 'promoNric', '')) && (get(savedCoverages, 'promoNric', '') !== nric)) {
      validQRClient ?  history.push('/mltc/lets-get-started?nricerror=true' + combineParamCC + combineAnalyticParam) : history.push('/mltc/choose-plan?nricerror=true' + combineParamCC + combineAnalyticParam);
      return false;
    }

    if(validQRClient && gioNricDetails && gioNricDetails !== nric){
        trackOnError?.('QR LTC nric validation', 'Please ensure NRIC matches with QR.','1');
        history.push('/mltc/lets-get-started?nricerror=true' + combineParamCC + combineAnalyticParam);
    }

    if (gioDeclaration === 'GIO' && gioNricDetails && gioNricDetails !== nric) {
      trackOnError?.('gio nric validation', 'Please ensure NRIC matches with GIO declaration.','1');
      validQRClient ?  history.push('/mltc/lets-get-started?nricerror=true' + combineParamCC + combineAnalyticParam) : history.push('/mltc/customise-plan?nricerror=true' + combineParamCC + combineAnalyticParam);
      return false;
    }

    if (cstopupCampaignValidity && gioNricDetails && gioNricDetails !== nric) {
      trackOnError?.('Campaign nric validation', 'Please ensure NRIC matches with Campaign declaration.','1');
      validQRClient ?  history.push('/mltc/lets-get-started?nricerror=true' + combineParamCC + combineAnalyticParam) : history.push('/mltc/customise-plan?nricerror=true' + combineParamCC + combineAnalyticParam);
      return false;
    }

    return true;
  }, [basicDetails, history, gioNricDetails, gioDeclaration, cstopupCampaignValidity, combineParamCC, combineAnalyticParam, validQRClient]);

  const saveMyInfo = useCallback(async (data: any, person: MyInfoPersonResponse, customerId: number = 0) => {
    console.debug(`QnB ➤ saveMyInfo(data, person)`, { data, person, addressValues, customerId, retrievedMyInfo });
    const { l400Profile } = addMyInfoValues;
    const id = retrievedMyInfo?.id || customerId;
    const postInfoRequest = new AddMyInfoRequest(null);
    postInfoRequest.patchWithPerson(person);
    postInfoRequest.patchWithValues(values);
    postInfoRequest.l400Profile = l400Profile ? l400Profile : l400ProfileSlice;
    postInfoRequest.isMailingAddressSame = isDifferenceAddressRef.current === 1 ? 'N' : 'Y';
    postInfoRequest.annualIncome = values['income'];
    postInfoRequest.exactDutiesOccupation = values['duties'];
    postInfoRequest.businessNature = "12";//values['nature'];
    postInfoRequest.businessNatureOthers = "NA";//values['otherBusiness'] || undefined;
    postInfoRequest.updateMailingAddFlag = values['updateMailing'] ? 'Y' : 'N';
    postInfoRequest.healthQuestions = '22,N|23,N|24,N|25,N|26,N';
    postInfoRequest.race = 'OTH';
    postInfoRequest.maritalStatus = '6'; //R3 - 6 = U from the BE
    postInfoRequest.height = healthDeclaration?.height;
    postInfoRequest.weight = healthDeclaration?.weight;

    console.log("EDIT ADDRESS addressValues",addressValues);
    if ( isDifferenceAddressRef.current === 1) {
      postInfoRequest.postalCodeMail = addressValues['postcode']==='-'?"":addressValues['postcode'];
      postInfoRequest.blockMail = addressValues['block']==='-'?"":addressValues['block'];
      postInfoRequest.unitMail = addressValues['unit']==='-'?"":addressValues['unit'];
      postInfoRequest.streetNameMail = addressValues['street']==='-'?"":addressValues['street'];
      postInfoRequest.buildingNameMail = addressValues['building']==='-'?"":addressValues['building'];
    }

    postInfoRequest.id = id;
    postInfoRequest.transactionId = transactionId;

    console.log(`QnB ➤ saveMyInfo() ➤ postInfoRequest ➤ `, { postInfoRequest });
    try {
      const savedResponse = await postSavingMyInfo(postInfoRequest);
      const persondId = get(savedResponse, 'data', 0);
      person.id = persondId;
      dispatch(updateRetrievedMyInfo(person));
      dispatch(updateHasMyInfo(true));
      return true;
      // trackFormSubmmit();
    } catch (error) {
      // setHasApiError(true);
      dispatch(setIsGlobalError(true));
      console.error(`QnB ➤ saveMyInfo() ➤`, { error });
      return false;
    }
  }, [addMyInfoValues, values, dispatch, isDifferenceAddressRef.current, addressValues, retrievedMyInfo]);


  const loadPerson = useCallback(async (res: any, loadNew: boolean = true) => {
    dispatch(updateMyInfoRawResponse(res));
    dispatch(setLoadingState(true));

    const data = get(res, 'data.person');
    const customerId = get(res, 'data.id', 0);
    const person = new MyInfoPersonResponse({ id: customerId, ...data });
    if (customerId) {
      person.id = customerId;
    }
    setMyInfoRawResponse(data);

    const agentInformation = new AgentPersonalDetailResponse(person.personalDetails);
    const address = mapAddressInfo(person.address);
    const myInfoForm = { ...values, ...agentInformation, ...person.address };

    if (loadNew) {
      patchValue(myInfoForm);
    }
    agentInformation.salutation = values['salutation'];
    setPersonalDetails(agentInformation);
    setAddressInformation(address);

    //Remove Marital and race, because R3 not taking marital and race anymore 
    if (
      isEmpty(person.personalDetails.dob) ||
      isEmpty(person.personalDetails.fullName) ||
      isEmpty(person.personalDetails.nationality) ||
      isEmpty(person.address.postal)) {
      dispatch(setLoadingState(false));
      if (!isGenericError) {
        setIsGenericError(true);
      }
      return;
    }

    //Validate if NRIC started with S or T
    if(person.personalDetails.nric){
      if(!Helpers.checkNricValid(person.personalDetails.nric)){
        dispatch(setLoadingState(false));
        if (!isGenericError) {
          setIsGenericError(true);
        }
        return;
      }
    }
    
    if (!checkBasicDetails(person.personalDetails)) {
      dispatch(setLoadingState(false));
      return;
    }

    if (loadNew) {
      if (!await checkRentalProperty(person.address.postal || '')) {
        dispatch(setLoadingState(false));
        return;
      }
      person.id = customerId;
      dispatch(updateRetrievedMyInfo(person));
      dispatch(updateMyInfoForm(new MyInfoForm(myInfoForm)));
      dispatch(updateMyInfoAddressForm(addressValues));
      dispatch(updatePersonalDetails({ ...agentInformation }));

      if (await saveMyInfo(data, person, customerId)) {
        // gotoNextStep();
        console.log("SAVE MY INFO COMPLETED");
      }
      // console.log('hasApiError', hasApiError);
    }
    nameChucksProcesses();
    dispatch(setLoadingState(false));
    setSingPassRetrieved(true);
  }, [dispatch, addressValues])


  const gotoContact = useCallback((rental: boolean = false) => {
    // check campaign flow
    if (campaignDetail?.code === 'LUB1') {
      setIsShowUOB(true);
    }
    if (analyticUrlParams && analyticUrlParams?.ecid === 'LUB1') {
      setIsShowUOB(true);
    } else if (campaignDetail?.code === CIMB_Code) {
      history.push(`/mltc/contact-form?variant=true` + combineParamCC + combineAnalyticParam);
    } else {
      if (rental) {
        history.push(`/mltc/contact-form?variant=true&rental=true` + combineParamCC + combineAnalyticParam)
      } else {
        history.push('/mltc/contact-form?variant=true' + combineParamCC + combineAnalyticParam)
      }
    }

  }, [history, campaignDetail]);

  const checkRentalProperty = useCallback(async (postal: string) => {
    try {
      const rentalResponse = await getRentalProperty(postal);
      const rentalProperty = get(rentalResponse, 'data.rentalProperty');
      const bypassRental = urlParams.get('rental');
      console.debug(rentalResponse, rentalProperty, bypassRental);
      if (rentalProperty && bypassRental !== 'true') {
        gotoContact(true);
        return false;
      }
      return true;
    } catch (error) {
      console.error(error);
      return true; //bypass
    }
  }, [urlParams, gotoContact]);



  const performSaveMyInfo = useCallback(async () => {

    // let res = personRawResponse;
    // const data = get(res, 'person');
    // const customerId = get(res, 'id', 0)
    // console.log("performSaveMyInfo data",data);
    // console.log("performSaveMyInfo cust ID",customerId);
    // console.log("performSaveMyInfo check retrievedMyInfo",retrievedMyInfo);
    // const person = new MyInfoPersonResponse({ id: customerId, ...data });

    const data = myInfoRawResponse;
    const person = new MyInfoPersonResponse(data);
    console.log("performdsavemyinfo myInfoRawResponse", myInfoRawResponse);
    await saveMyInfo(data, person);

  }, [myInfoRawResponse, saveMyInfo]);


  const onCompleteEditAddress = async () => {
    const rentalResponse = await getRentalProperty(addressValues['postcode']);
    const rentalProperty = get(rentalResponse, 'data.rentalProperty');
    const bypassRental = urlParams.get('rental');

    
    if (rentalProperty) {
      gotoContact(true);
    } else {
      isDifferenceAddressRef.current=1
      performSaveMyInfo();
      setAddressCompleted(true);
      console.log("dispatch updateMyInfoAddressForm", addressValues);
      dispatch(updateMyInfoAddressForm(addressValues));
      proceedToDelclaration();
    }

  }

  const onFindPlace = async () => {
    const checkLanded = ({ valid, partialAddress, addressLine3 }: { valid: boolean, partialAddress: boolean, addressLine3: string }) => {
      return valid === true && partialAddress === false && isEmpty(addressLine3);
    }
    dispatch(setLoadingState(true));
    const payload = new QASPostalCodeRequest({ postalCode: addressValues['postcode'] });
    try {
      const response = await postQASPostalAddress(payload);
      
      // const response = PostalCodeMockResponseValid; //VALID MOCK
      // const response = PostalCodeMockResponseInvalid; //INVALID MOCK
      
      console.log("onFindPlace response", response);
      const data = get(response, 'data');
      const { valid, partialAddress, addressLine3 } = data;
      setIsFindAddressValid(valid);
      const isLandedProperty = checkLanded({ valid, partialAddress, addressLine3 });
      console.log("IS landed", isLandedProperty);
      setLanded(isLandedProperty);
      if (!valid) {
        patchValueAddressForm(
          {
            block: '',
            unit: '',
            street: '',
            building: '',
          }
        )
        dispatch(setLoadingState(false));
      }
      else {
        const address = new QASPostalCodeResponse(data);
        console.debug({ data, address });
        dispatch(setLoadingState(false));
        const isLandedProperty = checkLanded({ valid, partialAddress, addressLine3 });
        const unit = get(address, 'addressLine3', undefined);
        setLanded(isLandedProperty);
        patchValueAddressForm(
          {
            block: get(address, 'addressLine1', ''),
            unit: isEmpty(unit) ? undefined : unit,
            street: get(address, 'addressLine2', ''),
            building: get(address, 'addressLine4', ''),
            isLanded: isLandedProperty
          }
        )
      }
      // ();
    } catch (error) {
      dispatch(setLoadingState(false));
      setIsFindAddressValid(false);
      console.error(error);
    }

  }

  const updateDropoffPoint = useCallback(async () => {
    return new Promise(async (resolve, reject) => {
      const isVulnerable = urlParams.get('vulnerable') === 'true';
      const isRental = urlParams.get('rental') === 'true';
      let productName = 'Singlife CareShield Standard';
      if (quoteRawResponse) {
        const planQuotation = new SQSPocketResponse(quoteRawResponse);
        productName = planQuotation.planName || '';
      }
      const agentCode = analyticUrlParams?.arc || '';
      const fullName = values["fullName"];
      const personalInfo = {...values, "fullname": fullName}
      const transactionID = transactionId || Number(getTimestamp())
      let payload: any = createContactRequest(personalInfo, isVulnerable, transactionID, isRental, campaignDetail?.campaignCode, productName, agentCode, isEBLTC, companyName);
      payload.dropPoint = isEBLTC ? 'QNB_MLTC_EBLTC_DROPOFF' : 'QNB_MLTC_SINGPASS_DROPOFF';
      try {
        await postContactMltc(payload);
      } catch (error) {
        console.error(error);
      }
      resolve("done");
    });
  }, [transactionId, personalDetails, values, campaignDetail, quoteRawResponse, analyticUrlParams]);


  const myInfoFormYesProcess = async () => {
    performSaveMyInfo();
    updateDropoffPoint();
    dispatch(updateMyInfoForm(values));
    dispatch(updatePersonalDetails(personalDetails));
    setMyInfoCompleted(true);
    
    trackOnLoad("mltc_myinfo_address_confirmation_form");
  }
  const nameChunks = (tempName: string, type: string, name: string) => {
    let tempObjFN: NameSelectorItemProps[] = [];
    let temp: string[] = [];
    const placeHolder = Symbol("placeholder")
    if (tempName && name) {
      const arr = tempName.split(" ");
      const nameaArr = name.split(" ");
      arr.forEach((e: any, i: number) => {
        const nameIndex = nameaArr.findIndex(
          (name: any, index: number) => name === e 
        );
        if(nameIndex !== -1){
          nameaArr.splice(nameIndex,1,placeHolder.toString());}
        const isFirstName = nameIndex !== -1;
        let tempFNChucks = {
          id: i,
          title: e,
          selected: isFirstName,
          order: nameIndex,
        };
        tempObjFN.push(tempFNChucks);
        temp.push(e);
      });
    }
    if (type === "givname") {
      setFirstNameListingChucks([...tempObjFN]);
    }

    if (type === "surname") {
      setLastNameListingChucks([...tempObjFN]);
    }
  };

  const nameChucksProcesses = () => {
    let fullName = values["fullName"] || get(initValue,"fullName")
    if(!fullName){
      return
    }
    const tempName = fullName.trim();
    let tempFirstName =
      values["givname"] ||
      get(initValue,"givname") ||
      (tempName && tempName.split(" ").slice(0, -1).join(" "));
    let tempLastName =
      values["surname"] ||
      get(initValue,"surname") ||
      (tempName && tempName.split(" ").pop());

    nameChunks(tempName, "givname", tempFirstName);
    nameChunks(tempName, "surname", tempLastName);
    patchValue({
      firstName: tempFirstName,
      lastName: tempLastName,
    });
  }

  const firstNameOnChange = (value: any) => {
    let tempName : string = values["fullName"];
    const fullName = tempName.trim();
    let firstNameItems = value.nameItems;

    let tempObjFirstName: NameSelectorItemProps[] = [];
    let tempObjLastName: NameSelectorItemProps[] = [];
    const arr = fullName.split(" ");

    arr.forEach((e: any, i: number) => {
      const nameIndex = firstNameItems.findIndex(
        (items: any) => i === items.id
      );
      const isFirstName = nameIndex !== -1;
      let tempFNChucks = {
        id: i,
        title: e,
        selected: isFirstName,
        order: nameIndex,
      };
      tempObjFirstName.push(tempFNChucks);
      tempObjLastName.push({ ...tempFNChucks, selected: !isFirstName });
    });

    let fname = "";
    let lname = "";
    firstNameItems.forEach((e: any, i: number) => {
      fname += e.title + " ";
    });
    tempObjLastName.forEach((e) => {
      e.selected && (lname += e.title + " ");
    });

    setFirstNameListingChucks([...tempObjFirstName]);
    setLastNameListingChucks([...tempObjLastName]);

    patchValue({
      givname: fname.trim(),
      surname: lname.trim(),
    });
    
  }

  const lastNameOnchange = (value: any) => {
    let tempName = values["fullName"];
    const fullName = tempName.trim();
    let lastNameItems = value.nameItems;

    let tempObjFirstName: NameSelectorItemProps[] = [];
    let tempObjLastName: NameSelectorItemProps[] = [];
    const arr = fullName.split(" ");

    arr.forEach((e: any, i: number) => {
      const nameIndex = lastNameItems.findIndex((items: any) => i === items.id);
      const isFirstName = nameIndex !== -1;
      let tempFNChucks = {
        id: i,
        title: e,
        selected: isFirstName,
        order: nameIndex,
      };
      tempObjLastName.push(tempFNChucks);
      tempObjFirstName.push({ ...tempFNChucks, selected: !isFirstName });
    });

    let fname = "";
    let lname = "";
    lastNameItems.forEach((e: any) => {
      lname += e.title + " ";
    });
    tempObjFirstName.forEach((e) => {
      e.selected && (fname += e.title + " ");
    });

    setFirstNameListingChucks([...tempObjFirstName]);
    setLastNameListingChucks([...tempObjLastName]);

    patchValue({
      givname: fname.trim(),
      surname: lname.trim(),
    });
  }

  // QB-AA-Tracking fix: maps each form name tracked on this page to its journey step.
  const MYINFO_STEP_INFO: Record<string, { stepName: string; stepNumber: string }> = {
    mltc_myinfo_singpass_form: { stepName: "Singpass Login", stepNumber: "11" },
    mltc_myinfo_details_form: { stepName: "Review My Info Details", stepNumber: "12" },
    mltc_myinfo_address_confirmation_form: { stepName: "Review My Info Address", stepNumber: "13" },
    mltc_myinfo_address_editing_form: { stepName: "Review My Info Address", stepNumber: "13" },
    mltc_myinfo_keep_in_touch_form: { stepName: "Review My Info Address", stepNumber: "13" },
  };

  const trackOnLoad = (formName: string): void => {
    if(!aaTracking.includes(formName)){
      setAATracking([...aaTracking,formName]);
      const GA = GAAviva.getInstance();
      let { form, page } = GA.digitalData;
      form.name = formName;

      const stepInfo = MYINFO_STEP_INFO[formName];
      page.journeyName = MLTC_R3_JOURNEY_NAME;
      page.stepName = stepInfo?.stepName || page.stepName;
      page.stepNumber = stepInfo?.stepNumber || page.stepNumber;

      GA.trackPageLoad({ form, page });
    }
  }

  const trackOnError = (fieldLabels: string, messages: string, numErrors: string): void => {
    const GA = GAAviva.getInstance();
    let { form } = GA.digitalData;
    form.error.fieldLabels = [fieldLabels];
    form.error.messages = [messages];
    form.error.numErrors = numErrors;
    GA.trackFormFailed({ form });
  }

  const trackOnMarketingOptIn = (value: any) => {

    let marketingOptIn: string[] = [];
    Object.entries(value).map(([key, value]) => {
      console.log("Object.entries", key, value);
      if (key === "phone" || key === "sms" || key === "email" || key === "mail") {
        if (value) marketingOptIn.push(key);
      }
    });

    const GA = GAAviva.getInstance();
    let { acquisition } = GA.digitalData;
    acquisition.customer.marketingOptIn = marketingOptIn.join(" | ");
    GA.trackPageLoad({ acquisition });
  }

  const proceedToDelclaration = async () => {

    performSaveMyInfo();

    dispatch(completeMyInfoStep(true));
    dispatch(updateDeclaration(declarationValues));
    dispatch(updateMyInfoForm(values));

    trackOnMarketingOptIn(declarationValues);
    
    history.push('/mltc/declaration' + paramCC + analyticParam);
  }


  //Init
  useEffect(() => {
    console.log("isStep3Completed", isStep3Completed);    
    if(gioDeclaration !== "GIO"){
      if (!isStep3Completed) {
        history.push('/mltc/health' + paramCC + analyticParam);
      };
      if (!planOverview || !sqsQuotation) {
        history.push('/mltc/lets-get-started' + paramCC + analyticParam);
      };
    }

    trackOnError("", "", "0");
    trackOnLoad("mltc_myinfo_singpass_form");
  }, []);

  useEffect(() => {
    setContactMethods(initInTouchValue);
    Array.isArray(initInTouchValue.value) && initInTouchValue.value.forEach((e: any) => {
      patchValueDeclaration({ [e]: true });
    });
    console.log("initInTouchValue", initInTouchValue);
  }, []);

  const loadRetrievedData = useCallback(() => {
    if (retrievedMyInfo) {
      const person = new MyInfoPersonResponse(retrievedMyInfo);
      const agentInformation = new AgentPersonalDetailResponse(person.personalDetails);
      const address = mapAddressInfo(person.address);
      setPersonalDetails(agentInformation);
      setAddressInformation(address);
      loadPerson(personRawResponse, false);
    }
  }, [retrievedMyInfo, loadPerson, personRawResponse]);


  useEffect(() => {

  }, [declarationValues])

  useEffect(() => {
    const transaction_id: string = urlParams.get('transaction_id') || '';
    const isInjectPerson = urlParams.get('inject');

    if (!isPageLoaded) {
      if (campaignDetail) {
        setCampaignCode(campaignDetail?.code);
      }
      if (!isStep3Completed && process.env.REACT_APP_INJECT_CHECK !== 'true') {
        if(gioDeclaration !== "GIO"){
          completeStep(false);
          history.push('/mltc/choose-plan' + paramCC + analyticParam);
        }else{
          loadRetrievedData();
          setIsPageLoaded(true);
        }
      } else {
        console.log("load retrieve data");
        loadRetrievedData();
        setIsPageLoaded(true);
      }
    }

    if (isInjectPerson === 'true' /*&& !isInjected*/) {
      setInjected(true);
      loadPerson(injectPersonData);
      return;
    } else {
      if (transaction_id) {
        handleConsent();
      }
    }


  }, [setCampaignCode]);




  useEffect(() => {
    if (myInfoFormRef.current) {
      isSingPassRetrieved ? myInfoFormRef.current.style.opacity = "1" : myInfoFormRef.current.style.opacity = "0";
      calculateSpacer(myInfoFormRef, SpacerRef, true);
    }
  }, [isSingPassRetrieved])


  useEffect(() => {
    if (isMyInfoCompleted) {
      if (AccordionRef.current) {
        AccordionRef.current.closeAccordion();
      }
      
      setTimeout(() => {
        if (myInfoAddressFormRef && myInfoAddressFormRef.current) {
          calculateSpacer(myInfoAddressFormRef, SpacerRef, true);
          var elementOffSetTop = myInfoAddressFormRef.current.offsetTop;
          console.log("myInfoAddressFormRef.current.offsetTop",myInfoAddressFormRef.current.offsetTop);
          var top = window.pageYOffset || document.documentElement.scrollTop;
          scrollToRef(document.documentElement, "scrollTop", "", top, elementOffSetTop, 600, true);
          myInfoAddressFormRef.current.style.opacity = "1";
        }
      }, 250);
    }
  }, [isMyInfoCompleted]);

  useEffect(() => {
    if (isAddressEdit) {
      setTimeout(() => {
        if (myInfoAddressEditFormRef && myInfoAddressEditFormRef.current) {
          calculateSpacer(myInfoAddressEditFormRef, SpacerRef, true);
          var elementOffSetTop = myInfoAddressEditFormRef.current.offsetTop;
          var top = window.pageYOffset || document.documentElement.scrollTop;
          scrollToRef(document.documentElement, "scrollTop", "", top, elementOffSetTop, 600, true);
          myInfoAddressEditFormRef.current.style.opacity = "1";
        }
      }, 100);
      trackOnLoad("mltc_myinfo_address_editing_form");
    }
  }, [isAddressEdit]);

  useEffect(() => {
    if (isAddressCompleted) {
    //   setTimeout(() => {
    //     if (myInfoInTouchRef && myInfoInTouchRef.current) {
    //       calculateSpacer(myInfoInTouchRef, SpacerRef, true);
    //       var elementOffSetTop = myInfoInTouchRef.current.offsetTop;
    //       var top = window.pageYOffset || document.documentElement.scrollTop;
    //       scrollToRef(document.documentElement, "scrollTop", "", top, elementOffSetTop, 600, true);


    //       myInfoInTouchRef.current.style.opacity = "1";
    //     }
    //   }, 100);
      trackOnLoad("mltc_myinfo_keep_in_touch_form");
      console.log("myinfointouch ref useeffect", contactMethods, declarationValues);
    }
  }, [isAddressCompleted]);


  useEffect(() => {
    if(isSingPassRetrieved) {
      trackOnLoad("mltc_myinfo_details_form");
    }
  }, [isSingPassRetrieved, values]);


  useEffect(()=>{
    nameChucksProcesses();
  },[ values["fullName"] ])

  useEffect(() => {
    if (Object.keys(infoFormErrors).length !== 0) {
      if (infoFormErrors?.givname.isValid && infoFormErrors?.surname.isValid && infoFormErrors?.salutation.isValid && infoFormErrors?.mobileNum.isValid && infoFormErrors?.emailId.isValid && infoFormErrors?.income.isValid && contactMethods.selected !== "") {
        setIsFormError(false);
      }
      else {
        setIsFormError(true);
      }

    }
  }, [values, infoFormErrors, contactMethods]);

  useEffect(() => {
    console.log(addressFormErrors);
    if (Object.keys(addressFormErrors).length !== 0) {

      if (isFindAddressValid && addressFormErrors?.postcode.isValid && addressFormErrors?.block.isValid && addressFormErrors?.street.isValid && (isLanded || addressFormErrors?.unit.isValid) && addressFormErrors?.building.isValid) {
        setInfoAddressFormErrors(false);
      }
      else {
        setInfoAddressFormErrors(true);
      }

      console.log("addressInformation", addressInformation);
      console.log("addressFormErrors", addressFormErrors);
    }
  }, [values, addressValues, addressFormErrors]);


  useEffect(() => {
    // if (myInfoInTouchTermsRef.current) {
      // if (contactMethods.length > 0) {
      //   //show touch terms conditions
      //   myInfoInTouchTermsRef.current.style.opacity = "1";

      // }
      // else {
      //   //close touch terms conditions
      //   if(screenSize > 768)
      //   {
      //     myInfoInTouchTermsRef.current.style.opacity = "0";
      //   }
      // }
    // }
    dispatch(updateMyInfoInTouch(contactMethods));
  }, [contactMethods]);



  useEffect(() => {
    console.log("Personal Deails", personalDetails)
  }, [personalDetails, setPersonalDetails]);

  useEffect(() => {
    window.addEventListener('resize', detectScreenWidth);
    return () => {
      window.removeEventListener('resize', detectScreenWidth);
    };
  }, [screenSize]);

  const toggleAddInfoForm = () => {
    setShowMyInfoPopup(!isShowMyInfoPopup);
  }

  const addMyInfo = () => {
    const form = new AddMyInfoForm(addMyInfoValues);
    const dataPerson = { data: { person: form.person } };
    patchValue({ salutation: form.salutation });
    loadPerson(dataPerson);
    setShowMyInfoPopup(false);
  }


  const onChangeSectionMyinfo = () => {
    setMyInfoCompleted(false);
    setAddressEdit(false);
    setAddressCompleted(false);
  }


  const postalCodeOnChange = (e:any) =>{
    patchValueAddressForm(
      {
        block: '',
        unit: '',
        street: '',
        building: '',
      }
    )
    setIsFindAddressValid(true);
    changeAddressForm(e)
  }



  return (
    <Container>
      <React.Fragment>
        <AddMyInfoModal
          show={isShowMyInfoPopup}
          onClose={toggleAddInfoForm}
          onChange={changeAddMyInfo}
          valid={addMyInfoFormValid}
          values={addMyInfoValues}
          errors={addMyInfoError}
          salutations={salutations}
          nationlaities={nationlaities}
          races={races}
          maritalStatus={maritalStatus}
          onSubmit={addMyInfo}
        />
        {!isSingPassRetrieved && <ContentContainer maxWidth={'792px'} margin={"150px auto 0"}>
          <SingpassPermission
            onClickRetrieveSingpass={onClickRetrieveSingpass}
            toggleAddInfoForm={toggleAddInfoForm}
            isGenericError={isGenericError}
            setIsGenericError={(closeError: boolean)=>setIsGenericError(closeError)}
          />
        </ContentContainer>}


        {isSingPassRetrieved && <FormContainer maxWidth={"792px"} margin={"150px auto 0"} ref={myInfoFormRef}>
          <FormHeaderContainer>
            <FormHeaderTitleContainer maxWidth={"588px"} marginHorizontal={"150px"}>
              <Text theme={themeDefault} align={"center"} className={HeaderTitleCss}>
                Check that your details are correct
              </Text>
            </FormHeaderTitleContainer>
            <FormHeaderDescriptionContainer>
              <Text theme={themeDefault} className={HeaderDescriptionCss}>
              Your personal information was filled automatically via MyInfo.
              </Text>
            </FormHeaderDescriptionContainer>
          </FormHeaderContainer>
          <FormContentContainer maxWidth={"588px"} margin={"auto"}>
            <FormContentItemsContainer className="fullname">
              <FormLabel>Full Name</FormLabel>
              <FullNameParagraph>{values['fullName']}</FullNameParagraph>
            </FormContentItemsContainer>
            <FormContentItemsContainer>
              <FormLabel>Salutation</FormLabel>
              <Dropdown value={values['salutation']} margin={"0 0 0"} theme={themeDefault} source={personalDetails.gender === "M" ? salutationListM : salutationListF}
                name="salutation" placeholder="Select"
                onChange={(e: any) => { handleChangeInfo(e); onChangeSectionMyinfo(); }}
              />
            </FormContentItemsContainer>
            <FormContentItemsContainer className="firstname">
              <FormLabel>First/Given Name</FormLabel>
              <Input margin={"0"} readOnly value={values['givname']} swap='1'></Input>
              <MessageNote>
                <span className={SpanParagraphCss} onClick={() => {
                  setFirstNameModalVisible(true);
                }}>Change</span> your First/Given Name
              </MessageNote>
            </FormContentItemsContainer>
            <FormContentItemsContainer className="lastname">
              <FormLabel>Last/Family Name</FormLabel>
              <Input margin={"0"} readOnly value={values['surname']} swap='1'></Input>
              <MessageNote>
                <span className={SpanParagraphCss} onClick={() => {
                  setLastNameModalVisible(true);
                }}>Change</span> your Last/Family Name
              </MessageNote>
            </FormContentItemsContainer>
            <FormContentItemsContainer style={{ marginBottom: 0 }}>
              <FormLabel>Mobile Number</FormLabel>
              <MobileInputGroup>
                <MobileCountryCode htmlFor="mobileNum">+65</MobileCountryCode>
                <Input id="mobileNum" margin={"0"} maxLength={8} name={'mobileNum'} type={"number"} value={values['mobileNum']} onChange={(e: any) => {
                  handleChangeInfo(e); onChangeSectionMyinfo();
                }}
                ></Input>
              </MobileInputGroup>
              <MessageNote color={"#C50000"}>{infoFormErrors.mobileNum.message}</MessageNote>
            </FormContentItemsContainer>
            <FormContentItemsContainer style={{ marginBottom: 0 }}>
              <FormLabel>Email</FormLabel>
              <Input margin={"0"} name={'emailId'} maxLength={50} value={values['emailId']} onChange={(e: any) => { handleChangeInfo(e); onChangeSectionMyinfo(); }}></Input>
              <MessageNote color={"#C50000"}>{infoFormErrors.emailId.message}</MessageNote>

            </FormContentItemsContainer>
            <FormContentItemsContainer>
              <FormLabel>Annual Income</FormLabel>
              <Dropdown margin={0} value={values['income']} theme={themeDefault} source={annualIncomeList}
                name="income" placeholder="Select"
                onChange={(e: any) => { handleChangeInfo(e); onChangeSectionMyinfo(); }}
              />
            </FormContentItemsContainer>
          </FormContentContainer>
          <FormContentContainer  maxWidth={"588px"} margin={"auto"}>
            <MarketTermsHeader>Let’s stay in touch – on your terms</MarketTermsHeader>
           <MarketTermsDescription>Experience better ways to financial freedom with our exclusive offers and news via email, mail, calls and messaging platforms. Simply tell us if you’re interested and update your preference anytime!</MarketTermsDescription>
           <Checkbox
          type="radio"
          checked={
            contactMethods?.selected === "Y"
          }
          name="stayInTouch"
          newRedio={true}
          onChange={(e) => {
            checkboxHandleChange("Y")
          }}
        >
          <TextNormal>
          Yes please, I want to hear about offers and news just for me
          </TextNormal>
        </Checkbox>
        <Checkbox
          type="radio"
          checked={
            contactMethods?.selected === "N"
          }
          name="stayInTouch"
          newRedio={true}
          onChange={(e) => {
            checkboxHandleChange("N")
          }}
        >
          <TextNormal>
              No thanks, I don’t want to hear about offers and news just for me
          </TextNormal>
        </Checkbox>
        <MarketTermsUpdate>Update your preference anytime, anywhere at  <MarketUpdateLinks href={DPOUrl} target={"_blank"} rel={"noopener noreferrer"} >MySinglife</MarketUpdateLinks> or contact Singlife at <MarketUpdateLinks href={"tel:+6568279933"} target={"_blank"} rel={"noopener noreferrer"} >+65 6827 9933</MarketUpdateLinks>.</MarketTermsUpdate>
        </FormContentContainer>


          <FormButtonContainer>
            {/* {isMyInfoCompleted &&
            <Button onClick={goBack} width={"180px"} variant={'secondary'} theme={themeDefault} label={"Back"}></Button>
          } */}
            <Button onClick={myInfoFormYesProcess} width={"180px"} variant={'default'} theme={themeDefault} disabled={isFormError} label={"Confirm"}></Button>
          </FormButtonContainer>



          <AccordionContainer>
            <Accordion ref={AccordionRef} {...accordionArgs} >
              <div style={{ paddingBottom: "20px" }}>
                <div>
                  <Text theme={themeDefault} className={AccordionParagraph}>You need to indicate your annual income when applying for our long-term care plans because we offer a Guaranteed Issuance Option (GIO), which gives you the flexibility to increase your coverage at key life stage events, without further health underwriting.</Text>
                  <br />
                  <Text theme={themeDefault} className={AccordionParagraph}>One of the life stage events is when your salary increases by more than 50% from your application.</Text>
                  <br />
                  <Text theme={themeDefault} className={AccordionParagraph}>The other life stage events are:</Text>
                  <br />
                </div>
                <Bullet><Text theme={themeDefault} className={AccordionParagraph}>when you purchase a property;</Text></Bullet>
                <Bullet><Text theme={themeDefault} className={AccordionParagraph}>when you marry, divorce or are widowed;</Text></Bullet>
                <Bullet><Text theme={themeDefault} className={AccordionParagraph}>when you become a parent by having a newborn child, or legally adopted a child below 19 ANB;</Text></Bullet>
                <Bullet><Text theme={themeDefault} className={AccordionParagraph}>when you complete a skills development course which takes at least 6 months</Text></Bullet>
                <Bullet><Text theme={themeDefault} className={AccordionParagraph}>when you purchase a new Individual Life insurance policy or a Supplementary Benefit from Singapore Life Ltd. with full underwriting at standard terms; or</Text></Bullet>
                <Bullet><Text theme={themeDefault} className={AccordionParagraph}>when your spouse suffers a severe disability (with the inability to perform at least 3 of the 6 ADL) or dies.</Text></Bullet>
                <div>
                  <Text theme={themeDefault} className={AccordionParagraph}>This option allows you to increase the Policy&apos;s monthly benefit with extra premium payable. The total monthly benefit that can be increased under this option is limited to 50% of the Policy&apos;s initial monthly benefit as agreed at policy inception or at the date this option is exercised, whichever is lower. This option is extended to standard life only. Please refer to the Product Summary for more details.</Text>
                </div>
              </div>
            </Accordion>
          </AccordionContainer>
        </FormContainer>}


        {isMyInfoCompleted && <FormContainer maxWidth={"652px"} margin={"150px auto 50px"} ref={myInfoAddressFormRef}>
          <FormHeaderContainer>
            <FormHeaderTitleContainer maxWidth={"588px"} marginHorizontal={"auto"}>
              <Text theme={themeDefault} align={"center"} className={HeaderTitleCss}>
                Is your mailing address the same as your residential address?
              </Text>
            </FormHeaderTitleContainer>
            <FormHeaderDescriptionContainer>
              <Text theme={themeDefault} className={HeaderDescriptionCss}>
                Your personal information was filled automatically via MyInfo.
              </Text>
            </FormHeaderDescriptionContainer>
          </FormHeaderContainer>
          <AddressListingContainer maxWidth={"588px"}>
            <Text className={AddressHeaderTitleCss}>Residential Address</Text>
            <Listing variant={'alternate'} margin={"0"} sources={[{ heading: addressInformation[3] }, { heading: addressInformation[1] }, { heading: addressInformation[2] }, { heading: addressInformation[0] }, { heading: addressInformation[4] }]}></Listing>
          </AddressListingContainer>
          <FormButtonContainer>
            <Button onClick={() => {
              setAddressEdit(true);
              isDifferenceAddressRef.current = 1;
              setAddressCompleted(false);
            }} width={"180px"} variant={isAddressEdit ? 'default' : 'secondary'} theme={themeDefault} label={"No"}></Button>
            <Button onClick={() => {
              isDifferenceAddressRef.current = 0;
              performSaveMyInfo();
              setAddressEdit(false);
              setAddressCompleted(true);
              // let myAddressObj = {
              //   'block': addressInformation[3].value,
              //   'building': addressInformation[4].value,
              //   'postcode': addressInformation[0].value,
              //   'street': addressInformation[2].value,
              //   'unit': addressInformation[1].value
              // }
              // let tempMyAddressForm = new MyInfoAddressForm(myAddressObj);
              // dispatch(updateMyInfoAddressForm(tempMyAddressForm));
              proceedToDelclaration();
            }} width={"180px"} variant={!isAddressEdit ? 'default' : 'secondary'} theme={themeDefault} label={"Yes"}></Button>
          </FormButtonContainer>

        </FormContainer>}

        {isAddressEdit && <FormContainer maxWidth={"588px"} margin={"150px auto 50px auto"} ref={myInfoAddressEditFormRef}>
          <FormHeaderContainer>
            <FormHeaderTitleContainer maxWidth={"588px"} marginHorizontal={"50px"}>
              <Text theme={themeDefault} align={"center"} className={HeaderTitleCss}>
                Please update your mailing address
              </Text>
            </FormHeaderTitleContainer>
            <FormHeaderDescriptionContainer>
              <Text theme={themeDefault} className={HeaderDescriptionCss}>
                We only accept Singapore addresses
              </Text>
            </FormHeaderDescriptionContainer>
          </FormHeaderContainer>
          <FormContentContainer margin={"0 0 48px 0"}>
            <FormContentItemsContainer style={{ marginBottom: 12 }}>
              <FormLabel isError={!isFindAddressValid}>Postal Code</FormLabel>
              <Input name={"postcode"} type={'number'} margin={"0"} maxLength={6} color={!isFindAddressValid ? "#C50000" : "#883E89"} value={addressValues['postcode']} placeholder={""} onChange={postalCodeOnChange}></Input>
              <MessageNote color={"#C50000"}>{!isFindAddressValid ? "We couldn't retrieve your address using the postal code you entered, so please try again" : ""}</MessageNote>
            </FormContentItemsContainer>
            <FormContentItemsContainer className={FormContentItemsSearchCss} style={{ marginBottom: 12 }}>
              <Button height={"52px"} width={"200px"} variant={"secondary"} onClick={onFindPlace} label={"Search"}></Button>
            </FormContentItemsContainer>
            <FormContentItemsContainer style={{ marginBottom: 12 }}>
              <FormLabel>Block</FormLabel>
              <Input disabled={!isFindAddressValid} name={"block"} margin={"0"} maxLength={30} value={addressValues['block']} placeholder={""} onChange={changeAddressForm}></Input>
            </FormContentItemsContainer>
            <FormContentItemsContainer style={{ marginBottom: 12 }}>
              <FormLabel>Street Name</FormLabel>
              <Input disabled={!isFindAddressValid} name={"street"} margin={"0"} maxLength={30} value={addressValues['street']} placeholder={""} onChange={changeAddressForm}></Input>
            </FormContentItemsContainer>
            <FormContentItemsContainer style={{ marginBottom: 0 }}>
              <FormLabel>Unit Number<UnitTooltipIconContainer onMouseOver={(e:any)=>{
                if(unitToolTipComponentRef.current) {
                  const targetClientRect = e.target.getBoundingClientRect();
                  unitToolTipComponentRef.current.openWebTooltip(targetClientRect.left - 60,targetClientRect.bottom-15);
                }
              }} onMouseLeave={() => {
                if(unitToolTipComponentRef.current) {
                  unitToolTipComponentRef.current.closeWebTooltip();
                }
              }}  onClick={()=>{
                if(unitToolTipComponentRef.current) {
                  unitToolTipComponentRef.current.openMobileTooltip();
                }
              }}><Icon width={18} name="info-primary"/></UnitTooltipIconContainer></FormLabel>
              <Input disabled={!isFindAddressValid} name={"unit"} margin={"0"} maxLength={30} value={addressValues['unit']} placeholder={""} onChange={changeAddressForm}></Input>
            </FormContentItemsContainer>
            <FormContentItemsContainer style={{ marginBottom: 0 }}>
              <FormLabel>Building Name</FormLabel>
              <Input disabled={!isFindAddressValid} name={"building"} margin={"0"} maxLength={30} value={addressValues['building']} placeholder={""} onChange={changeAddressForm}></Input>
            </FormContentItemsContainer>
          </FormContentContainer>

          <CheckboxAddressContainer >
            <Checkbox onChange={(e) => {
              setCheckUpdateAddressPolicy(e.target.value);
              patchValue({ updateMailing: e.target.value });
            }} theme={themeDefault}>
              <Text theme={themeDefault} className={checkBoxParagraphCss}>I would like to also update this mailing address for all my life and health policy(ies) with Singlife.*</Text>
            </Checkbox>
          </CheckboxAddressContainer>
          <Text theme={themeDefault} className={AddressTermsParagraph}>*Not applicable to MINDEF & MHA Group Insurance / POGIS</Text>

          <FormButtonContainer>
            <Button disabled={infoAddressFormErrors} onClick={onCompleteEditAddress} width={"282px"} variant={'default'} theme={themeDefault} label={"Looks Good"}></Button>
          </FormButtonContainer>

        </FormContainer>}


        {/* {isAddressCompleted && <FormContainer maxWidth={"610px"} margin={"150px auto 0"} ref={myInfoInTouchRef}>
          <FormHeaderContainer>
            <FormHeaderTitleContainer marginHorizontal={"0"}>
              <Text theme={themeDefault} align={"center"} className={HeaderTitleCss}>
                What's the best way for us to keep in touch?
              </Text>
            </FormHeaderTitleContainer>
            <FormHeaderDescriptionContainer>
              <Text theme={themeDefault} className={HeaderDescriptionCss}>
                We'll be sharing with you special marketing offers, promotions, and information about Singlife's products and services which may be of interest to you.
              </Text>
            </FormHeaderDescriptionContainer>
          </FormHeaderContainer>

          <CheckboxAddressContainerList>
            <CheckboxAddressContainer >
              <Checkbox name={"mail"} onChange={checkboxHandleChange} theme={themeDefault} checked={contactMethods.findIndex((e: any) => "mail" === e) !== -1}>
                <Text theme={themeDefault} className={CheckboxTextCss}>Mail</Text>
              </Checkbox>
            </CheckboxAddressContainer>
            <CheckboxAddressContainer >
              <Checkbox name={"email"} onChange={checkboxHandleChange} theme={themeDefault} checked={contactMethods.findIndex((e: any) => "email" === e) !== -1}>
                <Text theme={themeDefault} className={CheckboxTextCss}>Email</Text>
              </Checkbox>
            </CheckboxAddressContainer>
            <CheckboxAddressContainer >
              <Checkbox name={"sms"} onChange={checkboxHandleChange} theme={themeDefault} checked={contactMethods.findIndex((e: any) => "sms" === e) !== -1}>
                <Text theme={themeDefault} className={CheckboxTextCss}>Messages on any messaging platform (including SMS)</Text>
              </Checkbox>
            </CheckboxAddressContainer>
            <CheckboxAddressContainer >
              <Checkbox name={"phone"} onChange={checkboxHandleChange} theme={themeDefault} checked={contactMethods.findIndex((e: any) => "phone" === e) !== -1}>
                <Text theme={themeDefault} className={CheckboxTextCss}>Telephone Call</Text>
              </Checkbox>
            </CheckboxAddressContainer>

          </CheckboxAddressContainerList>


          <FormButtonContainer>
            <Button onClick={proceedToDelclaration} width={"282px"} variant={'default'} theme={themeDefault} label={"Proceed"}></Button>
          </FormButtonContainer>

          <CheckboxTermsContainer ref={myInfoInTouchTermsRef}>
            <Text theme={themeDefault} className={tncParagraph}>
              By selecting the above option(s), you consent to Singlife collecting, using, disclosing or transferring your personal data to Singlife related companies, third party service providers or intermediaries (including your financial adviser, where applicable), whether located in Singapore or elsewhere, for the
              above purposes. You can refer to <Link theme={themeDefault} url={ContactUsUrl} target={"_blank"} rel={"noopener noreferrer"} text={" Singlife's Data Protection Notice "} /> for
              further details. If you wish to withdraw your consent, you may contact our
              <Link theme={themeDefault} url={DPOUrl} target={"_blank"} rel={"noopener noreferrer"} text={" Data Protection Officer"} />.
            </Text>
          </CheckboxTermsContainer>
        </FormContainer>} */}
      </React.Fragment>


      <div ref={SpacerRef}></div>
      <Stepper steps={stepsList}></Stepper>


      <UnitToolTipComponent ref={unitToolTipComponentRef}/>

      <Modal show={isShowUOB} onClose={() => { setIsShowUOB(false) }}>
        <Text margin={'0px 0 30px'}>You will be redirected to our appointed intermediary - United Overseas Bank Limited (“UOB”) site to submit the contact me form.</Text>
        <ActionContainer>
          <Button margin="0 0 20px" label="Proceed" onClick={gotoUOBContact} />
          <Button variant="secondary" label="Cancel" margin={0} onClick={() => { setIsShowUOB(false) }} />
        </ActionContainer>
      </Modal>

      <BottomSheet />

      <ModalNameSelector show={firstNameModalVisible} onCancelClick={() => {
        setFirstNameModalVisible(false);
      }} onSaveClick={(value) => {
        setFirstNameModalVisible(false);
        let target = {
          target: {
            name: "givname", value: value
          }
        }
        handleChangeInfo(target);
        firstNameOnChange(value);
      }} headerTitle={"First/Given Name"} selectorItems={firstNameListingChucks} />


      <ModalNameSelector show={lastNameModalVisible} onCancelClick={() => {
        setLastNameModalVisible(false);
      }} onSaveClick={(value) => {
        setLastNameModalVisible(false);
        let target = {
          target: {
            name: "surname", value: value
          }
        }
        handleChangeInfo(target);
        lastNameOnchange(value);
      }} headerTitle={"Last/Family Name"} selectorItems={lastNameListingChucks} />

    </Container>
  )
}

export default MyInfo;


const PostalCodeMockResponsevalid = {
  data:{
    "addressLine1": "450",
    "addressLine2": "Hougang Avenue 10",
    "addressLine3": "",
    "addressLine4": "",
    "country": "Singapore",
    "postalCode": "530450",
    "valid": true,
    "partialAddress": true,
    "statusDescription": "",
    "countryCode": "SG"
  }
};

const PostalCodeMockResponseInvalid = {
  data:{
    "addressLine1": "45",
    "addressLine2": "Faber Park",
    "addressLine3": "",
    "addressLine4": "Faber Hills",
    "country": "Singapore",
    "postalCode": "129123",
    "valid": false,
    "partialAddress": false,
    "statusDescription": "postal code not matched",
    "countryCode": "SG"
  }
};

const loadPersonMockData = {
  "data": {
    "code": 0,
    "id": 69612,
    "person": {
      "uinfin": {
        "lastupdated": "2022-07-14",
        "source": "1",
        "classification": "C",
        "value": "S8102792G"
      },
      "name": {
        "lastupdated": "2022-07-14",
        "source": "1",
        "classification": "C",
        "value": "ANDIKA BIN TAUFAN"
      },
      "sex": {
        "lastupdated": "2022-07-14",
        "code": "M",
        "classification": "C",
        "source": "1",
        "desc": "MALE"
      },
      "race": null,
      "nationality": {
        "lastupdated": "2022-07-14",
        "code": "SG",
        "classification": "C",
        "source": "1",
        "desc": "SINGAPORE CITIZEN"
      },
      "dob": {
        "lastupdated": "2022-07-14",
        "source": "1",
        "classification": "C",
        "value": "1981-04-02"
      },
      "email": {
        "lastupdated": "2022-07-14",
        "source": "4",
        "classification": "C",
        "value": "myinfo15666@gmail.com"
      },
      "mobileno": {
        "lastupdated": "2022-07-14",
        "source": "4",
        "classification": "C",
        "areacode": {
          "value": "65"
        },
        "prefix": {
          "value": "+"
        },
        "nbr": {
          "value": "98789900"
        }
      },
      "regadd": {
        "lastupdated": "2022-07-14",
        "source": "1",
        "classification": "C",
        "type": "SG",
        "country": {
          "code": "SG",
          "desc": "SINGAPORE"
        },
        "unit": {
          "value": "190"
        },
        "street": {
          "value": "DUNEARN ROAD"
        },
        "block": {
          "value": "826"
        },
        "postal": {
          "value": "589449"
        },
        "floor": {
          "value": "05"
        },
        "building": {
          "value": ""
        }
      },
      "marital": null,
      "employment": null,
      "residentialstatus": null
    }
  }
};